module.exports = __webpack_public_path__ + "static/img/kols5.6b418e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols5.png
// module id = hN96
// module chunks = 0